// extracted by mini-css-extract-plugin
export var callCard = "_qm-0";
export var callMessageButton = "_qm-1";
export var helpIcon = "_qm-3";
export var helpIconContainer = "_qm-4";
export var verticalDivider = "_qm-2";